export default __webpack_public_path__ + "static/media/oilandgas.d468185e.png";